angular.module('impactx.tender').controller('NewestTenderCtrl', [
    '$scope',
    'dataGen',
    'ToolbarService',
    NewestTenderCtrl
]);

function NewestTenderCtrl($scope, dataGen, ToolbarService) {
    ToolbarService.setButtons([]);
    dataGen.getData($scope, {}, "/tender/newest");

    $scope.hasTenders = function() {
        return $scope.data.numOfTenders > 0
    }
}